var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddEelem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 38,
    viewBox: "228.883 12 65 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0h27A19.5 19.5 0 0 1 66 19.5h0A19.5 19.5 0 0 1 46.5 39h-27A19.5 19.5 0 0 1 0 19.5h0A19.5 19.5 0 0 1 19.5 0z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000",
    fill: "transparent",
    transform: "matrix(.98485 0 0 .97436 228.883 12)",
    "data-name": "Rectangle 1413"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2050"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Trac\\xE9 6622"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261 21.667v19.457",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 21.667v19.457",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#000",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Trac\\xE9 6623"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.728 31.395h-19.457",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.728 31.395h-19.457",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#000",
    fill: "transparent"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEelem);
export default __webpack_public_path__ + "static/media/addEelem.c972f588ac51b711657915dd9e29973f.svg";
export { ForwardRef as ReactComponent };